
import { defineComponent } from 'vue';
import { store } from '@/store';

export default defineComponent({
  props: {
    userId: { type: String, default: '' },
  },
  computed: {
    displayName(): string {
      const permissions = store.getters['permission/getPermissions'];
      const user = permissions.find((p: any) => p.userId === this.userId);
      return user?.userName || user?.email || this.userId;
    },
  },
  methods: {
    deleteUser() {
      if (this.userId) {
        store.dispatch('permission/REMOVE', this.userId);
      }
    },
  },
});
